import { useState, useEffect } from 'react';
import { Tooltip } from '@mui/material';
import { ProfileUser } from 'lib/types/users';
import { ExpandMoreRounded, ExpandLessRounded } from '@mui/icons-material';
import { CollabAvatar } from 'components/CollabAvatar';

interface Props {
  profileUser: ProfileUser;
}

export const TopCollaborators = ({
  profileUser,
}: Props) => {
  const [showAll, setShowAll] = useState(false);
  const COLLABORATORS_FIRST_PAGE = 10;

  useEffect(() => {
    setShowAll(false);
  }, [profileUser]);

  const showMoreIcon = (
    <Tooltip title={`See ${profileUser.collaborators.length - COLLABORATORS_FIRST_PAGE} more collaborators`} placement="top" arrow>
      <ExpandMoreRounded
        color="primary"
        fontSize="large"
        onClick={() => setShowAll(true)}
        className="m-1 rounded border border-orange cursor-pointer"
      />
    </Tooltip>
  );

  const showLessIcon = (
    <Tooltip title="Show less" placement="top" arrow>
      <ExpandLessRounded
        color="primary"
        fontSize="large"
        onClick={() => setShowAll(false)}
        className="m-1 rounded border border-orange cursor-pointer"
      />
    </Tooltip>
  );

  return (
    <div>
      <h6 className="font-bold text-lg mb-2 text-center">
        Top Collaborators
      </h6>
      <div className="flex flex-wrap justify-center items-center mb-2 gap-2">
        {profileUser.collaborators.slice(0, COLLABORATORS_FIRST_PAGE).map((c: any) => (
          <CollabAvatar
            username={c.username}
            key={c.id}
            collab={c}
          />
        ))}
        {(profileUser.collaborators.length > COLLABORATORS_FIRST_PAGE && !showAll)
          ? showMoreIcon
          : (
            profileUser.collaborators.slice(COLLABORATORS_FIRST_PAGE).map((c: any) => (
              <CollabAvatar
                username={c.username}
                key={c.id}
                collab={c}
              />
            ))
          )}
        {showAll && showLessIcon}
      </div>
    </div>
  );
};
